import getCmp from "../helpers/cmpHelpers";

let umeGlobalTabIndex = {};
const consentmanagerHandleBackground = () => {
    const tryInit = (attempts = 0) => {
        const cmp = getCmp();
        if (cmp === null) {
            if (attempts < 100) {
                setTimeout(() => tryInit(attempts + 1), 100);
            }
            return;
        }
        const consentData = cmp('getCMPData');
        if (consentData !== undefined && consentData !== null && consentData.consentstring === '') {
            document.body.classList.add('menu-open');
            umeGlobalTabIndex = lockTabIndex();
        }
        cmp('addEventListener', ['consent', handleConsentScreen, false], null);
        cmp('addEventListener', ['consentscreencustom', handleConsentScreen, false], null);
    };
    tryInit();
}
export default consentmanagerHandleBackground;

const handleConsentScreen = (e, o) => {
    if (e === 'consentscreencustom') {
        document.body.classList.add('menu-open');
        umeGlobalTabIndex = lockTabIndex();
    }
    if (e === 'consent') {
        document.body.classList.remove('menu-open');
        if (umeGlobalTabIndex && Object.keys(umeGlobalTabIndex).length > 0) {
            unlockTabIndex(umeGlobalTabIndex);
        }

    }
}
const lockTabIndex = () => {
    const selector =
        'div.cmppreviewroot, a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    const tabElements = document.querySelectorAll(selector);
    let tabArray = Array.from(tabElements)
        .map((elem) => {

            const tabIndex = elem.hasAttribute("tabindex")
                ? elem.getAttribute("tabindex")
                : null;

            elem.setAttribute("tabindex", -1);
            return {elem, tabIndex};
        })
    return tabArray;
}
const unlockTabIndex = (oldState) => {
    oldState.forEach(({elem, tabIndex}) => {
        if (tabIndex === null) {
            elem.removeAttribute("tabindex");
        } else {
            elem.setAttribute("tabindex", tabIndex);
        }
    });
}